// packages
import { ref } from '@vue/composition-api';

// store
import { useActions } from '@/hooks/use-store';

/**
 * Toggle botão da modal.
 * Implementado a estrutura & comportamento
 * do botão que permitirá dar toggle ( abrir & fechar )
 * a modal.
 * Desta forma evita-se a replicação de código ( HTML & JS ) e
 * também permite que o a modal esteja num componente diferente
 * que o botão.
 *
 * @category Functional component
 * @since 1.0.0
 *
 */
const showModal = ref( false );

/**
 * Irá chamar a acção `blockActionBar`
 * de forma a dar block a barra.
 *
 * @category Functional component
 * @param {Boolean} block
 * @since 1.0.0
 *
 */
const blockActionBar = block => {
    const { actions } = useActions();
    actions( 'controlActionBar', { value: block });

    if ( !block )
        actions( 'resetState', false );
};

/**
 * Toggle da modal.
 *
 * @category Functional component
 * @param {Boolean} show
 * @since 1.0.0
 *
 */
const toggleModal = ( show = true ) => {
    showModal.value = show;
    blockActionBar( show );
};

const modalButton = {
    functional: true,
    render: ( h, { props }) => {
        const buttonAttrs = {
            class: `${props.targetClass} display--inline-b background--transparent capitalize pointer`,
            attrs: {
                tabindex: 0
            },
            on: {
                click: () => toggleModal(),
                keydown: event => {
                    switch ( event.which ) {
                        case 13:
                            toggleModal();
                            break;
                        case 27:
                            toggleModal( false );
                            break;
                        default:
                            break;
                    }
                }
            }
        };

        return h( 'button', buttonAttrs, [ props.label ] );
    }
};

export {
    showModal,
    blockActionBar,
    modalButton
};